<template>
  <v-app> Logging in... </v-app>
</template>

<script lang="ts" setup></script>

<style scoped></style>
